/*
 * Assistant follow-ups (NEXUS-1384). The ⓘ help — how to use it and the example prompts — is
 * the wiki page User guide › Admin console › Admin assistant (web-admin docs/guide/
 * admin-assistant.md), shown by components/WikiHelp.tsx: one source of truth (Erwin, 2026-10-27).
 */

/** Next questions to offer after a report (deterministic, per report). */
export function followUpsFor(report: string, params: { days?: number; pump?: string }): string[] {
  const d = params.days ?? 30;
  switch (report) {
    case 'faults_by_pump':
      return ['Show the same by fault code', `Show the fault trend for the last ${Math.max(d, 90)} days`, 'Which of these faults are still open?'];
    case 'faults_by_code':
      return ['Which pumps had the most faults?', `Show the fault trend for the last ${d} days`];
    case 'faults_per_day':
      return ['Which pumps had the most faults?', 'What are the most common fault codes?'];
    case 'open_faults':
      return ['Which pumps had faults in the last 30 days?', 'What are the most common fault codes this month?'];
    case 'pump_overview':
      return params.pump
        ? [`Tell me about ${params.pump} over the last 90 days`, 'Which pumps have been offline for more than a day?']
        : [];
    case 'pumps_offline':
      return ['Which firmware versions are the pumps running?', 'Which faults are still open right now?'];
    case 'firmware_versions':
      return ['How did firmware updates go this month?', 'Which pumps have been offline for more than a day?'];
    case 'firmware_updates':
      return ['Which firmware versions are the pumps running now?', 'Which pumps have been offline for more than a day?'];
    case 'support_issues':
      return ['Which faults are still open right now?', 'Which pumps had faults in the last 30 days?'];
    case 'commands_by_user':
      return ['Which pumps had faults in the last 30 days?'];
    default:
      return [];
  }
}
